module.exports = __webpack_public_path__ + "static/media/feature.e84de050.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/feature.jpg
// module id = 281
// module chunks = 0